<div class="work-center-zone-picker">
  <div class="work-center-zone-picker__header">
    <div>
      <h3>{{ 'workCentersCatalog.zonePicker.title' | translate }}</h3>
      <p>{{ 'workCentersCatalog.zonePicker.description' | translate }}</p>
    </div>

    <button mat-icon-button
            type="button"
            (click)="close()"
            [attr.aria-label]="'common.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                  class="work-center-zone-picker__search">
    <mat-label>{{ 'workCentersCatalog.zonePicker.search' | translate }}</mat-label>
    <input matInput
           [ngModel]="searchTerm()"
           (ngModelChange)="updateSearch($event)"
           [placeholder]="'workCentersCatalog.zonePicker.searchPlaceholder' | translate">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="work-center-zone-picker__list">
    @if (filteredZones().length) {
      @for (zone of filteredZones(); track zone.zoneId) {
      <button type="button"
              class="work-center-zone-picker__item"
              [class.work-center-zone-picker__item--selected]="isSelected(zone.zoneId)"
              (click)="toggleZone(zone.zoneId)">
        <mat-checkbox [checked]="isSelected(zone.zoneId)"
                      (click)="$event.stopPropagation()"
                      (change)="toggleZone(zone.zoneId)">
        </mat-checkbox>
        <span>{{ zone.name }}</span>
      </button>
      }
    } @else {
      <div class="work-center-zone-picker__empty">
        <mat-icon>search_off</mat-icon>
        <span>{{ 'masterTable.noResults' | translate }}</span>
      </div>
    }
  </div>

  <div class="work-center-zone-picker__footer">
    <button mat-stroked-button
            type="button"
            class="btn-tone-neutral"
            (click)="close()">
      {{ 'common.cancel' | translate }}
    </button>
    <button mat-flat-button
            type="button"
            class="btn-tone-primary"
            (click)="confirm()">
      {{ 'common.select' | translate }}
    </button>
  </div>
</div>
